import { render } from "./NavBarPSS.vue?vue&type=template&id=1b38b70a&scoped=true"
import script from "./NavBarPSS.vue?vue&type=script&lang=js"
export * from "./NavBarPSS.vue?vue&type=script&lang=js"

import "./NavBarPSS.vue?vue&type=style&index=0&id=1b38b70a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b38b70a"]])

export default __exports__